// Local storage
const PERMATE_MARKETER_ID_KEY = 'permateMarketerId';
const PERMATE_OFFER_ID_KEY = 'permateOfferId';
// Cookie
const PERMATE_CLICK_KEY = 'pm_click';
const PERMATE_OFFER_KEY = 'pm_cep_o';
// Local storage expired time
const PERMATE_DATA_EXPIRED_TIME = 24 * 60 * 60 * 1000;

export {
  PERMATE_MARKETER_ID_KEY,
  PERMATE_OFFER_ID_KEY,
  PERMATE_DATA_EXPIRED_TIME,
  PERMATE_CLICK_KEY,
  PERMATE_OFFER_KEY,
};
